import {NgModule} from '@angular/core';
import {NavigationEnd, PreloadAllModules, Router, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guards/auth.guard';
import posthog from 'posthog-js';

const routes: Routes = [
  {path: '', redirectTo: 'tabs/home', pathMatch: 'full'},
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then((m) => m.TabsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'mechanic-login',
    loadChildren: () =>
      import('./pages/mechanic-login/mechanic-login.module').then((m) => m.MechanicLoginPageModule),
  },
  {
    path: 'mechanic-signup',
    loadChildren: () =>
      import('./pages/mechanic-signup/mechanic-signup.module').then(
        (m) => m.MechanicSignupPageModule
      ),
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then((m) => m.SignupPageModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth-routing.module').then((m) => m.AuthPageRoutingModule),
  },
  {
    path: 'signature-pad',
    loadChildren: () =>
      import('./pages/signature-pad/signature-pad.module').then((m) => m.SignaturePadPageModule),
  },
  {
    path: 'select-mechanic',
    loadChildren: () =>
      import('./pages/select-mechanic/select-mechanic.module').then(
        (m) => m.SelectMechanicPageModule
      ),
  },
  {
    path: 'splashscreen',
    loadChildren: () =>
      import('./pages/splashscreen/splashscreen.module').then((m) => m.SplashscreenPageModule),
  },
  {
    // path: 'buildquotelogin/:userId',
    path: 'buildquotelogin',
    loadChildren: () =>
      import('./pages/buildquotelogin/build-quotelogin.module').then(
        (m) => m.BuildQuoteloginPageModule
      ),
  },
  {
    path: 'select-mechanic',
    loadChildren: () =>
      import('./pages/select-mechanic/select-mechanic.module').then(
        (m) => m.SelectMechanicPageModule
      ),
  },
  // Must stay last: catches stale deep links (e.g. pre-2022 /welcome) that
  // otherwise throw NG04002 and leave the user on a blank screen.
  {path: '**', redirectTo: ''},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        posthog.capture('$pageview');
      }
    });
  }
}
